import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const AsyncHeartbeat = withAsync({
	loader: lazyForPaint(() => import(/* webpackChunkName: "heartbeat" */ '@atlassian/heartbeat')),
	LoadingSkeleton: () => null,
});
